import { render, staticRenderFns } from "./SetupCompanyPackage.vue?vue&type=template&id=498395db&scoped=true"
import script from "./SetupCompanyPackage.vue?vue&type=script&lang=js"
export * from "./SetupCompanyPackage.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyPackage.vue?vue&type=style&index=0&id=498395db&prod&lang=scss"
import style1 from "./SetupCompanyPackage.vue?vue&type=style&index=1&id=498395db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498395db",
  null
  
)

export default component.exports